import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import React from 'react';
import { mediaErrorType, MediaErrorType, MediaSupport } from "../view-model";
import { useMediaSupport } from "./use-media-support.hook";
export const useMediaDevices = () => {
  const support = useMediaSupport(MediaSupport.ENUMERATE_MEDIA);
  const [devices, setDevices] = React.useState([]);
  const [loading, setLoading] = React.useState(support);
  const [error, setError] = React.useState();
  const enumerateDevices = React.useCallback(() => {
    if (support) {
      setLoading(true);
      navigator.mediaDevices.enumerateDevices().then(setDevices).catch(e => setError(e)).finally(() => setLoading(false));
    } else {
      setError(mediaErrorType(MediaErrorType.NOT_SUPPORTED_ENUMERATE_MEDIA));
    }
  }, [devices]);
  React.useEffect(() => {
    enumerateDevices();
  }, []);
  return {
    loading,
    devices,
    error,
    refetch: enumerateDevices
  };
};